import func from '../libs/functions';
import _ from 'lodash'
import tags from './tags'

const workspaceusers = {
	namespaced: true,
	state: {
		workspaceusers: [],
		workspaceusersById: {}
	},
	getters: {
		workspaceusers(state){
			return state.workspaceusers
		},
		workspaceusersById(state){
			return state.workspaceusersById
		}
	},
	mutations: {
		updateWorkspaceusersByIndex(state, newWorkspaceuserObject){

			state.workspaceusers[newWorkspaceuserObject.index] = newWorkspaceuserObject.workspaceuser;
	
			state.workspaceusersById = func.arrayToObject(state.workspaceusers, '_id')
		},
		setWorkspaceusers(state, workspaceusers){
 			for( let i in workspaceusers){
				for(let e in workspaceusers[i].tags){
					let tagId = workspaceusers[i].tags[e];
					if (tags.state.tagsById[tagId].type && tags.state.tagsById[tagId].type.name == 'Role'){
					  workspaceusers[i].role =  tags.state.tagsById[tagId];
					}
 					if(tags.state.tagsById[tagId].name == 'Invited'){
					  workspaceusers[i].is_invited = true
					}else{
					  workspaceusers[i].is_invited = false
					}
				}
				//Manupulate if name not exist replace with screenname
				if(workspaceusers[i].pages){
					for(let e in workspaceusers[i].pages){
						let page = workspaceusers[i].pages[e];
							if(!page.name) workspaceusers[i].pages[e].name = workspaceusers[i].pages[e].screenName;
					}
				}
			} 
			state.workspaceusers = workspaceusers
			state.workspaceusersById = func.arrayToObject(workspaceusers, '_id')		
		}
	},
	actions: {
		setWorkspaceusers({ commit }, workspaceusers){
			commit('setWorkspaceusers', workspaceusers)
	},
	updateWorkspaceusersByIndex({ commit }, newWorkspaceuserObject){
		commit('updateWorkspaceusersByIndex', newWorkspaceuserObject)
}
},
}

export default workspaceusers;


// WEBPACK FOOTER //
// ./src/store/workspaceusers.js